import { z } from "zod";
import {
  VENDOR_ID,
  ROUTING_NUMBER,
  ACCOUNT_NUMBER,
  PAYMENT_TERMS,
  PAYMENT_METHOD,
  TAX_CODE,
  TAX_ID,
  STATE_TAX_ID,
  CURRENT_BALANCE,
  PREVIOUS_BALANCE,
  ZELLE_PHONE,
  ZELLE_EMAIL,
} from "./consts";

export const schema = z.object({
  [ROUTING_NUMBER]: z.string().optional(),
  [ACCOUNT_NUMBER]: z.string().optional(),
  [PAYMENT_TERMS]: z.string().min(1, "This field is required"),
  [PAYMENT_METHOD]: z.string().min(1, "This field is required"),
  [TAX_CODE]: z.string().optional(),
  [TAX_ID]: z.string().optional(),
  [STATE_TAX_ID]: z.string().optional(),
  [CURRENT_BALANCE]: z.string().optional(),
  [PREVIOUS_BALANCE]: z.string().optional(),
  [ZELLE_PHONE]: z.string().optional(),
  [ZELLE_EMAIL]: z.string().optional(),
  [VENDOR_ID]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
